import React, {useEffect, useMemo} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../../shared/reducers/modals';
import {Column, DescriptiveText, Icon, LoadingSpinner, Row, TextInput} from '../../../shared';
import debug from 'debug';
import {formatter} from '../../../shared/utils/utils';
import {isEntitled} from '../../../shared/reducers/user';
import useSWR from 'swr';
import {buildDriftStatuses} from '../../../shared/utils/models';
import {_getConfig} from '../../../shared/reducers/config';

const log = debug('circleblack:advisor:account:models');

const AccountModels = ({accountID, config, getConfig}) => {
  const {data: account} = useSWR(`/accounts/${accountID}/rebalancing?adjustCash=true`);
  const entitledDrift = isEntitled([{group: 'models', feature: 'drift', access: 'r'}]);
  const driftStatuses = useMemo(() => buildDriftStatuses(config), [config]);
  const [driftStatus, setDriftStatus] = React.useState(null);

  useEffect(() => getConfig(), []);
  useEffect(() => {
    if (account && entitledDrift) {
      setDriftStatus(driftStatuses.find(status => status.title === account.balancingAlert));
    }
  }, [account, config]);

  const getAssignedModelValue = () => {
    if (account.models.length === 1) {
      return account.models[0].title;
    }
    if (account.models.length > 1) {
      return 'Multiple Models';
    }
    return 'No Model';
  };

  log('account', account);

  if (!account || (entitledDrift && !driftStatus)) {
    return <LoadingSpinner/>;
  }

  return <Column height={'200px'} layout={{grow: 1}}>
    {entitledDrift
    && <Row wrap={false} justifySubRow={'center'}>
      {/*TODO popovers dont always work right away?*/}
      <Icon svg={driftStatus.image} description={driftStatus.description} color={driftStatus.color}/>
      <DescriptiveText color={driftStatus.color} width={'auto'}>{account.balancingAlert}</DescriptiveText>
    </Row>}
    <Row wrap={true} justifySubRow={'left'}>
      <TextInput readOnly={true}
                 width={'150px'}
                 layout={{grow: 1}}
                 type='text'
                 title={`Assigned Model${account.models.length > 1 ? 's' : ''}`}
                 placeholder=''
                 dataPoint={{name: 'models', value: getAssignedModelValue()}}/>
      <TextInput readOnly={true}
                 width={'150px'}
                 layout={{grow: 1}}
                 type='text'
                 title='Last Rebalance'
                 placeholder=''
                 dataPoint={{
                   name: 'lastRebalance',
                   value: account.lastRebalance ? formatter('datetime')(account.lastRebalance) : 'Never',
                 }}/>
    </Row>
  </Column>;
};

const mapStateToProps = state => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  getConfig: force => dispatch(_getConfig(force)),
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountModels);

AccountModels.propTypes = {
  accountID: PropTypes.number.isRequired,
  getConfig: PropTypes.func.isRequired,
  config: PropTypes.shape({
    models: PropTypes.shape({
      driftStatuses: PropTypes.object,
    }),
  }).isRequired,
  openModal: PropTypes.func.isRequired,
};
